import React from 'react';
import {
    Button,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCancel, faPlaneSlash } from '@fortawesome/free-solid-svg-icons';
import { TimesheetStatus } from '../timesheet/Timesheet';

export default class TimeOffRequestRejectButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            rejectionNotes: '',
            processing: false,
        };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    processRejection = async () => {
        const { processing } = this.state;

        if (processing) {
            return;
        }

        this.setState({ processing: true });
        const { onRejectClick } = this.props;
        const { rejectionNotes } = this.state;

        await onRejectClick(rejectionNotes);

        this.setState({
            showModal: false,
            processing: false,
            rejectionNotes: '',
        });
    };

    render() {
        const { timeOffRequest } = this.props;

        if (
            !timeOffRequest ||
            timeOffRequest.timesheetStatusId > TimesheetStatus.Submitted
        ) {
            return null;
        }

        const { showModal, rejectionNotes, processing } = this.state;

        const rejectionDisabled = !rejectionNotes || rejectionNotes.length < 5;

        return (
            <>
                <Button type="button" color="danger" onClick={this.toggleModal}>
                    <FontAwesomeIcon icon={faPlaneSlash} className="mr-1" />{' '}
                    Reject
                </Button>

                <Modal isOpen={showModal} toggle={this.toggleModal} size="lg">
                    <ModalHeader toggle={this.toggleModal}>
                        Reject Time Off Request
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            Please give some details regarding the rejection.
                        </div>

                        <Input
                            type="textarea"
                            value={rejectionNotes}
                            max={500}
                            maxLength={500}
                            onChange={(e) =>
                                this.setState({
                                    rejectionNotes: e.target.value,
                                })
                            }
                        />
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            <Button
                                type="button"
                                color="warning"
                                onClick={this.toggleModal}
                                className="mr-5"
                            >
                                <FontAwesomeIcon
                                    icon={faCancel}
                                    className="mr-1"
                                />{' '}
                                Cancel
                            </Button>

                            <Button
                                type="button"
                                color="success"
                                outline={rejectionDisabled}
                                disabled={rejectionDisabled}
                                onClick={this.processRejection}
                            >
                                <FontAwesomeIcon
                                    icon={faPlaneSlash}
                                    className="mr-1"
                                    pulse={processing}
                                />
                                Reject Time Off Request
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
